import { useEffect } from "react";
import { useShallow } from "zustand/shallow";

import { useMeuPlayState } from "@src/states/meuplay";
import { usePlayerState } from "@src/states/player";

/**
 * Ponte de ESTADO entre o player web e o app nativo (React Native WebView).
 *
 * Responsabilidade única: manter `window.__fabriccaPlayer` (isPlaying + metadados)
 * atualizado. O app nativo lê esse objeto a cada 1s (polling) e reconcilia a
 * notificação/RNTP. Não há push de estado.
 *
 * Os COMANDOS da notificação (play/pause) NÃO passam por aqui: o app nativo injeta
 * diretamente os eventos `remotePlay` / `remoteStop` no document, que o componente
 * PlayPause já escuta (mesma infra usada pelos Autoplays).
 */
export function useNativeBridge() {
  const status = usePlayerState(
    (state) => state.tracks[state.currentTrackId]?.status,
  );
  const [currentTrack] = usePlayerState(
    useShallow((state) => [state.currentTrack]),
  );
  const radio = useMeuPlayState((state) => state.radio);

  useEffect(() => {
    window.__fabriccaPlayer = {
      isPlaying: status === "playing",
      title: currentTrack.title || radio?.name || "",
      artist: currentTrack.artist || "",
      artwork: currentTrack.artwork_large || "",
    };
  }, [status, currentTrack, radio]);
}
